import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, image, url, structuredData }) => {
  const location = useLocation();
  const baseUrl = 'https://www.marketvendr.com';
  const fullUrl = url || `${baseUrl}${location.pathname}`;
  const defaultImage = `${baseUrl}/og-image.jpg`;

  useEffect(() => {
    // Update document title
    document.title = title || 'MarketVendr - UK Import & Distribution Services';

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Primary meta tags
    updateMetaTag('description', description || 'Import products to the UK legally and safely. MarketVendr provides UK distribution, customs clearance, and warehousing services for international businesses, including alcohol imports. Expert compliance and logistics from our UK warehouse.');
    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Additional SEO meta tags
    updateMetaTag('author', 'MarketVendr');
    updateMetaTag('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    updateMetaTag('googlebot', 'index, follow');
    updateMetaTag('language', 'English');
    updateMetaTag('geo.region', 'GB');
    updateMetaTag('geo.placename', 'Grimsby, UK');
    updateMetaTag('geo.position', '53.5654;-0.0755');
    updateMetaTag('ICBM', '53.5654, -0.0755');

    // Open Graph tags
    updateMetaTag('og:title', title || 'MarketVendr - UK Import & Distribution Services', true);
    updateMetaTag('og:description', description || 'Import products to the UK legally and safely. MarketVendr provides UK distribution, customs clearance, and warehousing services for international businesses, including alcohol imports.', true);
    updateMetaTag('og:url', fullUrl, true);
    updateMetaTag('og:image', image || defaultImage, true);
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:site_name', 'MarketVendr', true);
    updateMetaTag('og:locale', 'en_GB', true);
    updateMetaTag('og:image:width', '1200', true);
    updateMetaTag('og:image:height', '630', true);
    updateMetaTag('og:image:alt', title || 'MarketVendr - UK Import & Distribution Services', true);

    // Twitter tags
    updateMetaTag('twitter:card', 'summary_large_image', true);
    updateMetaTag('twitter:title', title || 'MarketVendr - UK Import & Distribution Services', true);
    updateMetaTag('twitter:description', description || 'Import products to the UK legally and safely. MarketVendr provides UK distribution, customs clearance, and warehousing services for international businesses.', true);
    updateMetaTag('twitter:image', image || defaultImage, true);
    updateMetaTag('twitter:image:alt', title || 'MarketVendr - UK Import & Distribution Services', true);

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);

    // Add structured data if provided
    if (structuredData) {
      let structuredDataScript = document.querySelector('script[type="application/ld+json"][data-seo="true"]');
      if (!structuredDataScript) {
        structuredDataScript = document.createElement('script');
        structuredDataScript.setAttribute('type', 'application/ld+json');
        structuredDataScript.setAttribute('data-seo', 'true');
        document.head.appendChild(structuredDataScript);
      }
      structuredDataScript.textContent = JSON.stringify(structuredData);
    }
  }, [title, description, keywords, image, fullUrl, structuredData, defaultImage]);

  return null;
};

export default SEO;

